import {ROOT_DIR} from "../../App";
import {Helmet} from "react-helmet";
import {useSearchParams} from "react-router-dom";

function Pagination({totalItems, itemsPerPage, page, changePage}) {
    const pages = Math.ceil(totalItems / itemsPerPage);
    const [searchParams] = useSearchParams();

    if (pages <= 1) {
        return (<></>);
    }

    searchParams.set("page", (page + 1).toString());
    const paramsNext = searchParams.toString();

    searchParams.set("page", (page - 1).toString());
    const paramsPrev = searchParams.toString();

    return (
        <>
            <Helmet>
                {(page - 1 > 0) ?
                    <link rel="prev" href={ROOT_DIR + window.location.pathname + "?" + paramsPrev}/> : ""}
                {(page + 1 <= pages) ?
                    <link rel="next" href={ROOT_DIR + window.location.pathname + "?" + paramsNext}/> : ""}
            </Helmet>
            <nav className="flex justify-center w-full">
                <ul className="flex items-center -space-x-px h-10 text-base">
                    <li>
                        <button onClick={() => changePage(page - 1)}
                                className="flex items-center justify-center px-4 h-10 ms-0 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 hover:bg-gray-100 hover:text-gray-700">
                            <span className="sr-only">Précédent</span>
                            <svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true"
                                 xmlns="http://www.w3.org/2000/svg"
                                 fill="none" viewBox="0 0 6 10">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M5 1 1 5l4 4"/>
                            </svg>
                        </button>
                    </li>
                    {[...Array(pages).keys()].map((index) => (
                        <li key={index}>
                            <button onClick={() => changePage(index + 1)}
                                    className={"z-10 flex items-center justify-center px-4 h-10 leading-tight border " +
                                        ((page === index + 1) ? "text-primary border-primary-light bg-blue-50 hover:bg-blue-100 hover:text-blue-700" :
                                            "text-gray-500 bg-white border border-e-0 border-gray-300 hover:bg-gray-100 hover:text-gray-700") +
                                        ((index === page) ? " border-l-primary-light" : "")}>
                                {index + 1}
                            </button>
                        </li>
                    ))}
                    <li>
                        <button onClick={() => changePage(page + 1)}
                                className={"flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700" +
                                    ((pages === page) ? " border-l-primary-light" : "")}>
                            <span className="sr-only">Prochain</span>
                            <svg className="w-3 h-3 rtl:rotate-180" aria-hidden="true"
                                 xmlns="http://www.w3.org/2000/svg"
                                 fill="none" viewBox="0 0 6 10">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="m1 9 4-4-4-4"/>
                            </svg>
                        </button>
                    </li>
                </ul>
            </nav>
        </>
    );
}

export default Pagination;